import {
  HttpEvent,
  HttpHandler,
  HttpInterceptor,
  HttpRequest,
  HttpResponse,
} from "@angular/common/http";
import { Injectable, Injector } from "@angular/core";
import { ConfigurationService } from "providers/configuration/configuration.service";
import { Observable } from "rxjs/Observable";
import { tap } from "rxjs/operators";
import { AppStatus, ConnectionStatusEnum } from "../app-status/app-status";
import { MobileUtilsProvider } from "../mobile-utils/mobile-utils";
import { OfflineAsmtDataServiceProvider } from "../offline-asmt-data-service/offline-asmt-data-service";
import { STATIC_API_PATTERNS } from "../offline-manager/offline-globals";
import { OfflineRequestProcessor } from "../offline-manager/offline-request-processor";
import { RewriteEndpoint } from "./rewrite-models";
import { regexConcat, rewriteRules } from "./rewrite-rules";

// TODO: move to ProtectedModule and rename to reflect the focus of functionality
@Injectable()
export class CustomHttpInterceptor implements HttpInterceptor {
  offlineRequestProcessor: any;

  constructor(
    public appStatus: AppStatus,
    public inj: Injector,
    public mobileUtils: MobileUtilsProvider,
    private asmtDataManager: OfflineAsmtDataServiceProvider,
    private config: ConfigurationService
  ) {
    this.offlineRequestProcessor = inj.get(OfflineRequestProcessor);
  }

  intercept(
    request: HttpRequest<any>,
    next: HttpHandler
  ): Observable<HttpEvent<any>> {
    // If the app is offline, block http request and handle data offline
    if (
      this.mobileUtils.isMobilePlatform() &&
      this.appStatus.getAppStatus() === ConnectionStatusEnum.Offline
    ) {
      return this.offlineRequestProcessor.handleRequestOffline(request);
    } else if (this.mobileUtils.isMobilePlatform()) {
      // Check and save static/read only API responses for offline use
      let apiPath = this.checkStaticDataAPI(request);
      if (apiPath) {
        return this.saveStaticResponses(apiPath, request, next);
      }
    }

    if (this.config.getConfig()?.isLocal) {
      return next.handle(this.rewrite(request));
    }

    return next.handle(request);
  }

  checkStaticDataAPI(request: HttpRequest<any>): string {
    let apiPath;

    for (var i = 0; i < STATIC_API_PATTERNS.length; i++) {
      let apiPattern = STATIC_API_PATTERNS[i];
      if (apiPattern.pattern.test(request.url)) {
        apiPath = apiPattern.apiPath;
        break;
      }
    }

    return apiPath;
  }

  saveStaticResponses(
    apiPath: string,
    request: HttpRequest<any>,
    next: HttpHandler
  ): Observable<HttpEvent<any>> {
    console.log("Save response for offline use: ", request.url);
    return next.handle(request).pipe(
      tap((event) => {
        if (event instanceof HttpResponse) {
          this.asmtDataManager.saveStaticData({
            apiPath,
            apiResponse: JSON.stringify(event.body),
          });
        }
      })
    );
  }

  rewrite(request: HttpRequest<any>) {
    let updatedRequest = request;
    const rewriteEndpoints: RewriteEndpoint[] =
      this.config.getConfig().rewriteEndpoints;
    if (rewriteEndpoints) {
      for (const rewriteEndpoint of rewriteEndpoints) {
        for (const [_service, endpoint] of Object.entries(rewriteEndpoint)) {
          // Check if service enabled
          if (!endpoint.enabled) {
            continue;
          }
          for (const rule of endpoint.rules) {
            // Check if individual rule enabled
            if (!rule.enabled) {
              continue;
            }
            const rewriteRule = rewriteRules[rule.name];
            // Check if rewrite rule exists
            if (!rewriteRule) {
              continue;
            }
            const urlWithoutParams = request.url.split("?")[0];
            const fromExact = regexConcat([rewriteRule.from, /$/]);
            if (fromExact.test(urlWithoutParams)) {
              const newUrl = request.url.replace(
                rewriteRule.from,
                rewriteRule.to
              );
              updatedRequest = request.clone({ url: newUrl });
              console.debug(`Rewriting ${request.url} to ${newUrl}`);
            }
          }
        }
      }
    }
    return updatedRequest;
  }
}



// WEBPACK FOOTER //
// ./src/providers/custom-http-interceptor/custom-http.interceptor.ts